const imgBlock = document.getElementById("quiz-image-container");
let imgElement = document.getElementById("quiz-image-element");
const progressWrapper = document.getElementById("progress-wrapper");
const progressCount = document.getElementById("question-progress-count");
const quizContainer = document.querySelector(".tangnt-quiz-container");
const quizBlock = document.querySelector(".tangent-quiz-block");
const quizParentBlock = document.querySelector(".tangent-quiz-parent-block");
const tangentMainContainer = document.getElementById("tangent-main-container");
const isMobile = window.matchMedia("(max-width: 768px)").matches;
console.log(isMobile, "is mobile")
let isPopupOpened = false;
let zipcode = "";

const imageAssetUrls = [
    "https://cdn.shopify.com/s/files/1/0797/0871/7090/files/9157071311445082-question_1.jpg",
    "https://cdn.shopify.com/s/files/1/0797/0871/7090/files/9157071311445082-question_1.jpg",
    "https://cdn.shopify.com/s/files/1/0797/0871/7090/files/40826662293988036-question_2.jpg",
    "https://cdn.shopify.com/s/files/1/0797/0871/7090/files/9684947081857764-question_3.jpg",
    "https://cdn.shopify.com/s/files/1/0797/0871/7090/files/7119558049191594-question_4.jpg",
    "https://cdn.shopify.com/s/files/1/0797/0871/7090/files/6925300289376368-question_5.jpg",
    "https://cdn.shopify.com/s/files/1/0797/0871/7090/files/9883925887048826-question_6.jpg",
    "https://cdn.shopify.com/s/files/1/0797/0871/7090/files/42616738441488367-question_7.jpg",
    "https://cdn.shopify.com/s/files/1/0797/0871/7090/files/1844765838024418-question_8.jpg",
    "https://cdn.shopify.com/s/files/1/0797/0871/7090/files/25426614434242456-question_9.jpg",
    "https://cdn.shopify.com/s/files/1/0797/0871/7090/files/6409170377252871-question_10.jpg",
    "https://cdn.shopify.com/s/files/1/0797/0871/7090/files/5452017106992022-question_11.jpg",
    "https://cdn.shopify.com/s/files/1/0797/0871/7090/files/43808428926996656-question_12.jpg",
    "https://cdn.shopify.com/s/files/1/0797/0871/7090/files/6925300289376368-question_13.jpg"
];

(function preloadImages() {
  imageAssetUrls.forEach(url => {
    const img = new Image();
    img.src = url;
  });
})();

window.addEventListener("quiz_initialized", (event)=> {
    let [currentQ, totalQ] = event.detail.split("_");
    currentQ = Number(currentQ);
    totalQ = Number(totalQ) - 6;
    progressCount.innerHTML = `1/${totalQ}`;
    applyCountAndProgress(currentQ + 1, totalQ);
    document.addEventListener("click", (e) => {
        if (!e.target.closest(".tangent_68b6c7687fd3905ff86fc034_survey_next_button_custom")) return;
        zipcode = document.querySelector(".tangent_68b6c7687fd3905ff86fc034_inputs_container_custom>div>input").value;
    },true);
})

window.addEventListener("quiz_progress", (event) => {
  let [rawCurrent, rawTotal] = event.detail.split("_");

  let currentQ = Number(rawCurrent);
  let totalQ = Number(rawTotal) - 6;

  let displayQ = getDisplayQuestion(currentQ);

  // Hide progress at end
  if (rawCurrent == rawTotal) {
    progressWrapper.style.display = "none";
    applyCountAndProgress(displayQ, totalQ);
    return;
  }

  // Show popup only for Q1
  if (currentQ === 1) {
    displayTangentPopup();
  }

  changeQuizHeroImage(displayQ, imgElement);
  applyCountAndProgress(displayQ, totalQ);
  progressCount.innerHTML = `${displayQ}/${totalQ}`;
});

const getDisplayQuestion = (currentQ) => {

  // First question → show as 1
  if (currentQ === 0 || currentQ === 1) {
    return 1;
  }

  // Clamp 4–9 to 4
  if (currentQ > 4 && currentQ <= 9) {
    return 4;
  }

  // Shift after 5
  if (currentQ >= 5) {
    return currentQ - 5;
  }

  return currentQ;
}


const applyCountAndProgress = (current, totalQ) => {
    const progressBar = document.getElementById('tangent-progress-bar');

    // prevent crash if element is missing
    if (!progressBar) return;

    const progress = Math.min((current / totalQ) * 100, 100);
    progressBar.style.width = progress + '%';
}

//"https://file.tangent.ai/quiz-content/merchants/9bsp6a-9k/image/1646442174296039-question_0.jpg",

const changeQuizHeroImage = (index, imgElement) => {
    imgElement.src = imageAssetUrls[index]
    console.log(imageAssetUrls[index], "image url")
}

const displayTangentPopup = () => {
    let popupContentBlock = document.createElement("div");
    popupContentBlock.classList.add("tangent-zipcode-content-block");
    
    let htmlCode = "";
    if(isUSZipCode(zipcode)){ 
        const zipMetaDetails = estimateUSEnvironment();
        const classText = getClassText(zipMetaDetails)
        htmlCode = `
        <p class='zipcode-infor-description'>Environmental factors like climate, air quality and pollen count influence your allergies. We use your location to tailor the suggestions you see.</p>
        <div class='tangent-zipcode-info-block'>
        <div class='tangent-zipcode-feature-block'>
        <svg width="64px" height="64px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path fill="#A21438" d="M203.438 18.03c-67.86 1.023-136.07 52.442-99.313 177.25-19.902-13.32-39.808-19.272-58.906-19.56-10.183-.188-20.25 1.35-29.814 4.093v35.625c41.434-13.075 92.35 3.578 129.125 82.843 6.98 21.464 11.43 42.784 12.282 63.783.01.135.023.27.032.406 2.555 41.148-9.763 82.74-37.813 110.905l-.03.03c-5.6 6.838-11.908 13.59-18.938 20.25h88.657c40.943-75.566 10.117-177.693-32.657-256.374C61.293 62.965 216.36 8.983 273.813 78.595c-.73.677-1.412 1.37-2 2.062-3.516 4.14-4.307 7.733-3.532 10.625.776 2.894 3.26 5.58 8.376 7.407 5.115 1.83 12.405 2.254 20 .22 7.595-2.036 13.735-6.048 17.25-10.188 3.516-4.142 4.307-7.734 3.53-10.626-.773-2.892-3.258-5.578-8.373-7.406-1.364-.488-2.897-.856-4.532-1.126-16.407-33.118-58.672-52.17-101.092-51.53zm138.906 57.064c-1.34.004-2.7.03-4.094.062-.752.018-1.54.066-2.313.094 1.464 7.842-.846 15.62-5.187 22.094 11.955 2.052 22.79 7.44 31.78 15.187 15.9 13.704 26.68 34.14 32.533 56.876 5.59 21.722 6.758 45.878 2.5 68.75 17.686 2.86 36.728.448 56-8.875-27.56-41.117-29.818-84.612-40.344-113.218-5.646-15.34-12.687-26.02-26.783-33.03-9.91-4.93-23.99-8-44.093-7.938zm-91.28 23.562c-19.422 10.637-31.17 20.938-37.658 30.72-8.7 13.12-9.438 25.922-6.656 42.03 5.188 30.042 24.974 68.815 21.656 118.22 24.052-1.756 43.48-10.922 58.03-24.75-13.913-16.595-24.252-36.427-30.155-56.47-6.687-22.71-7.837-46.057-1.03-66.187 3.25-9.608 8.51-18.43 15.72-25.72-.21-.07-.418-.144-.626-.22-8.492-3.034-16.005-9.036-19.28-17.624zm70.405 16.28c-.74-.01-1.497.01-2.25.033-4.023.128-8.28.8-12.783 2.03-18.347 5.01-28.343 15.97-33.5 31.22-5.156 15.25-4.57 35.065 1.282 54.936 11.26 38.24 41.692 75.175 79.25 83.47 26.593-26.993 33.356-74.27 23.5-112.563-5.13-19.92-14.62-37.03-26.626-47.375-8.442-7.276-17.797-11.564-28.875-11.75zm89.81 153.72c-7.487-.08-14.92 5.072-14.967 15.656-.085 21.17 31.096 20.53 30.375 0-.36-10.264-7.92-15.576-15.407-15.656zm47.845 37.688c-1.918.045-4.008.583-6.156 1.812-13.75 7.866-1.66 27.832 11.374 19.688 10.997-6.872 5.14-21.742-5.22-21.5zm-79.938 1.78c-3.497.068-7.04 1.88-9.53 6.157-1.274 2.187-1.82 4.313-1.813 6.283-8.494-2.006-18.446 2.92-18.5 15.187-.084 21.17 31.065 20.53 30.344 0-.05-1.444-.247-2.753-.563-4 3.836.202 7.76-1.557 10.188-6.125 4.958-9.33-2.432-17.647-10.125-17.5zM282.938 312c-4.673.09-9.45 2.535-12.78 8.25-10.66 18.29 16.67 33.295 26.312 15.156 6.627-12.47-3.25-23.602-13.533-23.406zm-217.75 18.688c18.723 32.207-17.638 68.048-49.78 57.906v27.375c53.067 20.35 102.378-60.32 49.78-85.283zm384.75 21.562c-1.918.045-3.976.615-6.125 1.844-13.747 7.866-1.69 27.832 11.344 19.687 10.997-6.87 5.14-21.772-5.22-21.53zm-66.78 20.688c-9.66.1-19.234 6.733-18.782 19.625.905 25.782 38.044 26.586 38.156 0 .055-13.294-9.715-19.726-19.374-19.625zm-68.188 12.406c-3.498.067-7.072 1.91-9.564 6.187-7.972 13.685 12.476 24.915 19.688 11.345 4.958-9.33-2.432-17.68-10.125-17.53zm161.75 23.53c-7.692.08-15.3 5.36-14.94 15.626.723 20.53 30.252 21.17 30.345 0 .042-10.584-7.716-15.705-15.406-15.625zm-206.19 11.72c-7.487-.08-14.89 5.072-14.936 15.656-.084 21.17 31.065 20.53 30.344 0-.36-10.265-7.92-15.576-15.407-15.656zm142.5 14.375c-1.917.044-3.975.614-6.124 1.842-13.747 7.867-1.69 27.8 11.344 19.657 10.997-6.873 5.14-21.743-5.22-21.5zm-64.686 25.967c-11.434.42-20.318 15.264-9.813 26.532C352.54 502.49 375.028 480.905 360 466c-3.757-3.727-7.845-5.202-11.656-5.063zm119.812.844c-10.358-.24-16.215 14.63-5.22 21.5 13.035 8.146 25.093-11.79 11.345-19.655-2.147-1.23-4.206-1.8-6.124-1.844z"/></svg>
        <p class='tangent-zipcode-feature'>Pollen: ${zipMetaDetails.pollenIndex}/12
        <span class='${classText.pollen.class}'>${classText.pollen.text}</span>
        </p>
        </div>
        <div class='tangent-zipcode-feature-block'>
        <svg fill="#000000" width="64px" height="64px" viewBox="0 0 64 64" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path fill="#A21438" d="M49.7,35.9C47.3,21.2,29.5,4,28.7,3.3c-0.4-0.4-1-0.4-1.4,0C26.4,4.1,6,23.7,6,39c0,12.1,9.9,22,22,22c3.4,0,6.7-0.8,9.7-2.3c2.1,1.4,4.6,2.3,7.3,2.3c7.2,0,13-5.8,13-13C58,42.5,54.6,37.8,49.7,35.9z M28,59C17,59,8,50,8,39    C8,26.1,24.4,9,28,5.4C31.3,8.7,45,23,47.6,35.3C46.7,35.1,45.9,35,45,35c-7.2,0-13,5.8-13,13c0,3.7,1.5,7,4,9.3C33.5,58.4,30.8,59,28,59z M45,59c-6.1,0-11-4.9-11-11s4.9-11,11-11s11,4.9,11,11S51.1,59,45,59z"/><path fill="#A21438" d="M28,54c-8.3,0-15-6.7-15-15c0-0.6-0.4-1-1-1s-1,0.4-1,1c0,9.4,7.6,17,17,17c0.6,0,1-0.4,1-1S28.6,54,28,54z"/><path fill="#A21438" d="M48.4,40.1c-0.5-0.2-1.1,0-1.3,0.5l-6,14c-0.2,0.5,0,1.1,0.5,1.3C41.7,56,41.9,56,42,56c0.4,0,0.8-0.2,0.9-0.6l6-14    C49.1,40.9,48.9,40.3,48.4,40.1z"/><path fill="#A21438" d="M44,44c0-1.7-1.3-3-3-3s-3,1.3-3,3s1.3,3,3,3S44,45.7,44,44z M40,44c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1S40,44.6,40,44z"/><path fill="#A21438" d="M49,49c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S50.7,49,49,49z M49,53c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S49.6,53,49,53z"/></svg>
        <p class='tangent-zipcode-feature'>Humidity: ${zipMetaDetails.humidity}%
        <span class='${classText.humidity.class}'>${classText.humidity.text}</span>
        </p>
        </div>
        <div class='tangent-zipcode-feature-block'>
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g><g>		<path fill="#A21438" d="M503.983,495.967h-12.398c-39.624-72.296-47.184-175.651-48.233-229.505c0.151-0.614,0.238-1.251,0.238-1.91c0-0.757-0.112-1.485-0.308-2.178c-.273-19.219,0.276-31.182,0.297-31.623c0.11-2.193-0.684-4.337-2.198-5.927c-1.514-1.592-3.613-2.493-5.809-2.493H291.609c-1.439-16.331-1.928-26.144-1.948-26.561c-0.2-4.278-3.725-7.644-8.008-7.644H93.528c-4.283,0-7.809,3.366-8.008,7.645c-0.083,1.801-8.93,179.325-65.469,300.197H8.017c-4.427,0-8.017,3.589-8.017,8.017C0,508.411,3.589,512,8.017,512h495.967c4.427,0,8.017-3.589,8.017-8.017C512,499.556,508.411,495.967,503.983,495.967zM427.285,238.363c-0.106,4.489-0.19,10.653-0.154,18.171H295.138c-0.761-6.467-1.424-12.544-2-18.171H427.285z M101.082,204.159h173.019c0.29,4.389,0.738,10.551,1.392,18.171H99.69C100.345,214.71,100.791,208.548,101.082,204.159z M37.67,495.967c16.653-37.401,37.559-98.649,52.021-191.086c3.981-25.444,6.693-48.368,8.507-66.517h178.785c1.815,18.149,4.527,41.074,8.507,66.517c14.462,92.437,35.368,153.686,52.021,191.086H37.67z M355.13,495.967c-32.997-70.544-49.753-160.44-57.999-223.399H427.38c0.406,15.763,1.37,35.018,3.422,56.276c6.572,68.092,20.91,124.218,42.657,167.123H355.13z"/></g></g><g><g><path fill="#A21438" d="M461.228,42.756c-7.937,0-15.592,1.827-22.55,5.322c-4.742-8.848-12.652-15.95-22.362-19.625c-5.622-2.127-11.415-2.998-17.294-2.604C388.023,9.778,369.732,0,350.063,0c-15.557,0-30.516,6.191-41.592,17.102h-26.817c-56.287,0-102.079,45.792-102.079,102.079v42.756c0,4.427,3.589,8.017,8.017,8.017s8.017-3.589,8.017-8.017c0-38.809,25.875-72.395,62.585-82.732c4.947,17.913,21.27,30.891,40.563,30.891c5.471,0,10.802-1.085,15.913-3.23c3.25,2.427,6.72,4.499,10.351,6.201c1.266,22.151,19.683,39.785,42.145,39.785c6.297,0,12.432-1.394,18.055-4.07c9.225,8.085,21.029,12.622,33.252,12.622c14.577,0,28.476-6.402,38.079-17.339c1.585,0.158,3.137,0.236,4.676,0.236c27.995,0,50.772-22.777,50.772-50.772C512,65.533,489.223,42.756,461.228,42.756z M321.119,91.437c-2.58-2.328-6.368-2.728-9.378-0.989c-4.152,2.398-8.52,3.614-12.985,3.614c-13.938,0-25.374-10.965-26.034-24.963c-0.109-2.309-1.209-4.458-3.019-5.897c-1.81-1.439-4.154-2.026-6.426-1.612c-28.036,5.107-51.631,21.367-66.549,43.702c6.658-40.867,42.206-72.157,84.926-72.157h30.243c2.278,0,4.448-0.968,5.968-2.664c8.23-9.176,19.966-14.439,32.198-14.439c15.713,0,30.222,8.558,37.867,22.332c1.698,3.06,5.185,4.665,8.614,3.965c4.87-0.994,9.482-0.63,14.097,1.117c8.519,3.224,14.817,10.623,16.437,19.307c1.489,7.981-0.482,15.737-5.551,21.839c-4.998,6.018-12.346,9.469-20.157,9.469c-4.464,0-8.833-1.216-12.986-3.614c-3.01-1.738-6.797-1.338-9.377,0.989c-7.991,7.208-18.271,11.176-28.944,11.176C339.39,102.614,329.11,98.645,321.119,91.437z M461.228,128.267c-2.062,0-4.209-0.219-6.566-0.67c-3.068-0.587-6.199,0.661-8.021,3.199c-6.549,9.125-17.079,14.573-28.169,14.573c-9.961,0-19.169-4.219-25.929-11.88c-2.684-3.043-7.218-3.598-10.56-1.298c-4.392,3.027-9.516,4.626-14.818,4.626c-11.848,0-21.877-7.911-25.099-18.726c2.637,0.36,5.306,0.555,7.996,0.555c12.8,0,25.175-4.149,35.394-11.781c5.11,2.146,10.442,3.23,15.913,3.23c12.594,0,24.436-5.56,32.49-15.256c7.2-8.668,10.565-19.794,9.521-31.037c5.379-3.277,11.478-5.013,17.847-5.013c19.155,0,34.739,15.583,34.739,34.739S480.382,128.267,461.228,128.267z"/></g></g></svg>
        <p class='tangent-zipcode-feature'>Pollution: ${zipMetaDetails.pollutionAQI} AQI
        <span class='${classText.aqi.class}'>${classText.aqi.text}</span>
        </p>
        </div>
        </div>`;
    }else{    
        htmlCode = `
        <p class='tangent-popup-title'>Zipcode is invalid</p>
        <p class='tangent-popup-description'>The ZIP code you entered is invalid. Please go back and edit it, or continue with the quiz.</p>`;
    }

    popupContentBlock.innerHTML = htmlCode;
    setTimeout(() => {
      let popupBlock = document.getElementById("tangent-zipcode-block");
      popupBlock.appendChild(popupContentBlock);
    }, 100);
}

//<p class='tangent-popup-description'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent lacus nunc, porttitor in pharetra consectetur, eleifend eu nulla. Cras nec eleifend felis, at fringilla magna. Proin sed gravida nisi.</p>

const getClassText = (zipMeta) => {
  const classText = {};

  // POLLEN
  if (zipMeta.pollenIndex < 4) {
    classText.pollen = { class: "tangent-green", text: "Low" };
  } else if (zipMeta.pollenIndex < 7) {
    classText.pollen = { class: "tangent-orange", text: "Moderate" };
  } else {
    classText.pollen = { class: "tangent-red", text: "High" };
  }

  // AQI
  if (zipMeta.pollutionAQI <= 50) {
    classText.aqi = { class: "tangent-green", text: "Good" };
  } else if (zipMeta.pollutionAQI <= 100) {
    classText.aqi = { class: "tangent-orange", text: "Moderate" };
  } else if (zipMeta.pollutionAQI <= 150) {
    classText.aqi = { class: "tangent-orange", text: "Unhealthy" };
  } else if (zipMeta.pollutionAQI <= 200) {
    classText.aqi = { class: "tangent-red", text: "Unhealthy" };
  } else {
    classText.aqi = { class: "tangent-red", text: "Very Unhealthy" };
  }

  // HUMIDITY
  if (zipMeta.humidity <= 30) {
    classText.humidity = { class: "tangent-orange", text: "Dry" };
  } else if (zipMeta.humidity <= 50) {
    classText.humidity = { class: "tangent-green", text: "Comfortable" };
  } else if (zipMeta.humidity <= 60) {
    classText.humidity = { class: "tangent-green", text: "Slightly Humid" };
  } else if (zipMeta.humidity <= 70) {
    classText.humidity = { class: "tangent-orange", text: "Humid" };
  } else {
    classText.humidity = { class: "tangent-red", text: "Very Humid" };
  }

  return classText;
};


const continuePopupBtn = () => {
    document.getElementById("tangent-popup-container").style.display = "none";
    document.querySelector(".tangent_68b6c7687fd3905ff86fc034_survey_next_button_custom").click();
    const el = document.querySelector(".tangent-popup-content-block");
    if (el) el.remove();
}

const editTangentPopupBtn = () => {
    isPopupOpened = false;
    document.getElementById("tangent-popup-container").style.display = "none";
    const el = document.querySelector(".tangent-popup-content-block");
    if (el) el.remove();
}

const isUSZipCode = (zip) => {
  if (typeof zip !== 'string' && typeof zip !== 'number') return false;

  const zipStr = String(zip).trim();

  // US ZIP: 5 digits or 5+4 digits
  const usZipRegex = /^\d{5}(-\d{4})?$/;

  return usZipRegex.test(zipStr);
}

/* ============================================================
   US Environmental Approximation Module (FINAL)
   No APIs • No NPM • Single-file • US-only
   ============================================================ */

/* ---------------- ZIP → Region Rules ---------------- */

const ZIP_REGION_RULES = [
  { min: 99500, max: 99999, lat: 64, coastal: true  }, // Alaska
  { min: 96700, max: 96899, lat: 21, coastal: true  }, // Hawaii

  { min: 90000, max: 96699, lat: 36, coastal: true  }, // West Coast
  { min: 80000, max: 89999, lat: 39, coastal: false }, // Mountain
  { min: 70000, max: 79999, lat: 32, coastal: true  }, // South Central / Gulf
  { min: 60000, max: 69999, lat: 42, coastal: false }, // Midwest
  { min: 50000, max: 59999, lat: 44, coastal: false }, // Upper Midwest
  { min: 40000, max: 49999, lat: 38, coastal: false }, // Ohio Valley
  { min: 30000, max: 39999, lat: 34, coastal: true  }, // Southeast
  { min: 20000, max: 29999, lat: 40, coastal: true  }, // Mid-Atlantic
  { min: 10000, max: 19999, lat: 43, coastal: true  }, // Northeast
];

/* ---------------- Utilities ---------------- */

const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

const seededRandom = (seed) => {
  const x = Math.sin(seed) * 10000;
  return x - Math.floor(x);
};

const jitter = (value, range, seed) =>
  value + (seededRandom(seed) - 0.5) * range;

/* ---------------- ZIP → Geography ---------------- */

const estimateLatitudeFromZip = (zip) => {
  const z = Number(zip);
  for (const r of ZIP_REGION_RULES) {
    if (z >= r.min && z <= r.max) {
      const ratio = (z - r.min) / (r.max - r.min);
      return r.lat + (ratio - 0.5) * 6;
    }
  }
  return 39;
};

const inferUrbanLevel = (zip) => {
  const z = Number(zip);
  if (z % 100 === 0) return 4;
  if (z < 20000) return 4;
  if (z < 50000) return 3;
  if (z < 80000) return 2;
  return 1;
};

const inferCoastal = (zip) => {
  const z = Number(zip);
  if (z >= 90000 && z <= 96699) return true;
  if (z >= 10000 && z <= 19999) return true;
  if (z >= 30000 && z <= 39999) return true;
  if (z >= 70000 && z <= 72999) return true;
  if (z >= 96700 && z <= 96899) return true;
  return false;
};

const inferClimateBelt = (lat, coastal) => {
  if (lat < 30 && !coastal) return "hot-dry";
  if (lat < 30 && coastal) return "hot-humid";
  if (lat <= 40) return coastal ? "temperate-humid" : "temperate";
  return "cool";
};

/* ---------------- UV Index ---------------- */

const estimateUV = (lat, month) => {
  const seasonal = clamp(0.3 + 0.7 * Math.cos((month - 6) * Math.PI / 6), 0.3, 1);
  const latitudeFactor = clamp(Math.cos((lat - 37) * Math.PI / 180), 0.45, 1);

  const winterFloor = clamp(6 - (lat - 25) * 0.15, 1.5, 5);
  const peakUV = Math.max(11 * seasonal * latitudeFactor, winterFloor);

  return clamp(Math.round(jitter(peakUV, 1.2, lat * 31 + month * 13)), 1, 11);
};

/* ---------------- Humidity ---------------- */

const estimateHumidity = (lat, month, coastal, climate) => {
  let base = coastal ? 65 : 45;
  if (climate === "hot-humid") base += 10;
  if (climate === "hot-dry") base -= 10;

  const seasonal = Math.cos((month - 7) * Math.PI / 6) * 10;

  return clamp(Math.round(jitter(base + seasonal, 8, lat * 17 + month)), 20, 95);
};

/* ---------------- AQI ---------------- */

const estimateAQI = (lat, month, urban, climate) => {
  const urbanBase = [18, 35, 60, 95][urban - 1];
  const winter = (month <= 2 || month === 12) ? 35 : 0;
  const summer = (month >= 6 && month <= 8) ? 25 : 0;
  const climatePenalty = climate === "hot-humid" ? 15 : climate === "hot-dry" ? 10 : 0;
  const mixing = Math.abs(lat - 40) * 0.6;

  return clamp(Math.round(urbanBase + winter + summer + climatePenalty - mixing), 10, 300);
};

/* ---------------- Pollen Index ---------------- */

const estimatePollen = (lat, month, climate, coastal, zip) => {
  let seasonalBase = 1;
  if (month >= 3 && month <= 5) seasonalBase = 6;
  if (month >= 6 && month <= 7) seasonalBase = 5;
  if (month >= 8 && month <= 10) seasonalBase = 4;

  const latitudeBoost = clamp(5 - (lat - 25) * 0.18, 0, 4);
  const climateFactor = climate === "hot-humid" ? 1.5 : climate === "hot-dry" ? 0.5 : 0;
  const coastalPenalty = coastal ? -0.7 : 0;

  const raw = seasonalBase + latitudeBoost + climateFactor + coastalPenalty;

  return clamp(Math.round(jitter(raw, 2, lat * 19 + month * 11 + Number(zip))), 1, 12);
};

/* ---------------- Public API ---------------- */

const estimateUSEnvironment = () => {
  const zip = zipcode.split("-")[0];
  const date = new Date();
  const month = new Date(
    date.toLocaleString("en-US", { timeZone: "America/Chicago" })
  ).getMonth() + 1;

  const lat = estimateLatitudeFromZip(zip);
  const coastal = inferCoastal(zip);
  const urban = inferUrbanLevel(zip);
  const climate = inferClimateBelt(lat, coastal);

  return {
    uvIndex: estimateUV(lat, month),
    humidity: estimateHumidity(lat, month, coastal, climate),
    pollutionAQI: estimateAQI(lat, month, urban, climate),
    pollenIndex: estimatePollen(lat, month, climate, coastal, zip),
    meta: { lat, coastal, urban, climate },
    confidence: "approximate",
  };
};

/* ============================================================
   Example:
   estimateUSEnvironment({ zip: "94107" })
   ============================================================ */